<template>
  <v-list-item
    style="border-top-left-radius: 0; border-bottom-left-radius: 0;"
    :data-tourid="tourId"
    :ripple="false"
    :class="{
      'menu-active-item': menu && isActive,
      'nav-item-menu': menu,
      'nav-item node': !menu,
      'active-item': isActive && !menu && !isSubItem,
      'ps-8': !mini,
      'px-0': menu,
      'active-sub-item': isSubItem && isActive,
      'rounded ms-10 me-4': isSubItem,
    }"
    :data-testid="`navigationDrawer-button-${title}`"
    @click="navigate"
  >
    <v-tooltip v-if="!isSubItem || (isSubItem && mini)" right>
      <template v-slot:activator="{ on }">
        <v-list-item-icon
          v-on="mini ? on : null"
          :class="{ 'mr-0': mini, 'mr-5': !isSubItem && !mini }"
        >
          <v-icon
            class="font-size-24"
            :color="isActive ? 'white' : 'blue-grey'"
            >{{ isActive ? activeIcon : inactiveIcon }}</v-icon
          >
        </v-list-item-icon>
      </template>

      {{ title }}
    </v-tooltip>

    <v-list-item-content :ripple="false">
      <v-list-item-title
        v-if="!mini"
        class="d-flex align-center overflow-visible"
      >
        <p
          class="ma-0 pa-0 me-2 font-size-14 font-weight-medium"
          :class="{
            'blue-grey--text': !isActive,
            'white--text': isActive,
          }"
          style="letter-spacing: 0.75px;"
        >
          {{ title }}
        </p>

        <NavigationItemBadge
          v-if="badgeText"
          :color="badgeColor"
          :text="badgeText"
          :tooltipText="badgeTooltip"
        />
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import _ from 'lodash'

import trackerMixin from '@/mixins/tracking/trackerMixin.vue'
import mixin from '@/mixins/mixin.vue'

import NavigationItemBadge from '@/App/NavigationItemBadge.vue'

export default {
  name: 'NavigationItem',

  mixins: [trackerMixin, mixin],

  components: {
    NavigationItemBadge,
  },

  props: {
    menu: Boolean,
    external: Boolean,

    query: {
      default: () => {},
      type: Object,
    },

    title: {
      type: String,
      required: true,
    },

    href: {
      type: String,
      required: false,
    },

    activeIcon: {
      type: String,
      required: false,
    },

    inactiveIcon: {
      type: String,
      required: false,
    },

    tourId: {
      type: String,
      required: false,
    },

    mini: {
      type: Boolean,
      default: false,
    },

    isSubItem: {
      type: Boolean,
      default: false,
    },

    badgeText: {
      type: String,
    },

    badgeTooltip: {
      type: String,
    },

    badgeColor: {
      type: String,
    },
  },

  computed: {
    ref() {
      const currentUrl = '/' + this.$route.path.split('/')[1]

      if (currentUrl !== this.href) {
        if (_.isEmpty(this.query)) return this.href
        const queryParams = Object.keys(this.query)
          .map(key => {
            if (Array.isArray(this.query[key]))
              return this.query[key].map(value => `${key}=${value}`).join('&')
            return `${key}=${this.query[key]}`
          })
          .join('&')
        return `${this.href}?${queryParams}`
      }
      return this.href ?? null
    },

    isActive() {
      if (this.isSubItem) return this.$route.path === this.href
      const currentUrl = this.$route.path.split('/')[1]
      const href = this.href.split('/')[1]
      return currentUrl === href
    },
  },

  methods: {
    navigate() {
      this.trackMenuNavigate({ view: this.href.split('/')[1] })
      if (this.external) return this.openExternalRouteInNewTab(this.href)

      const currentPath = this.$route.path.split('/')[1]
      const href = this.href.split('/')[1]

      if (this.menu && !this.query && currentPath === href) return

      this.navigateTo(this.ref)
    },
  },
}
</script>

<style lang="scss" scoped>
.active-item {
  box-shadow: inset 4px 0 0 0 $color-blue;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  background: $color-blue-grey-darken2;
}

.nav-item:hover {
  background: $color-blue-grey-darken2;
}

.nav-item-menu:active {
  background: $color-blue-grey-darken3;
}

.menu-active-item {
  box-shadow: inset 4px 0 0 0 $color-blue;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  &:hover {
    background: $color-blue-grey-darken2;
  }
}

.active-sub-item {
  background: $color-blue-grey-darken2;
}
</style>
